<template>
  <div>
    <v-row>
      <v-dialog
        v-model="dialog"
        v-if="!(detailProfile.user_network_id > 0)"
        persistent
        max-width="900"
        scrollable
      >
        <v-card>
          <v-card-title class="h6">
            <span class="primary--text font-weight-bold">
              <v-icon class="mt-n1" color="primary">mdi-file-account</v-icon>
              <span class="pl-3 font-weight-bold">Form Reseller</span>
            </span>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              color="pink"
              class="mr-n4"
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-form ref="registrationMLM" role="form">
              <div class="pt-5">
                <v-col>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Nomor KTP
                        </div>
                        <v-text-field
                          v-model="identity_number"
                          @blur="checkKTP()"
                          @keypress="onlyNumber"
                          @paste="validatePaste($event)"
                          @focus="() => (ktp_error = '')"
                          :error-messages="ktp_error"
                          validate-on-blur
                          maxlength="16"
                          :rules="rulesKTP"
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          placeholder="Nomor KTP"
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Tipe Member
                        </div>
                        <v-autocomplete
                          v-model="type_selected"
                          :items="type_member_option"
                          return-object
                          item-text="text"
                          item-value="value"
                          :rules="rulesTypeMember"
                          @focus="() => (member_type_error = '')"
                          :error-messages="member_type_error"
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          dense
                          hide-details="auto"
                          no-data-text="Tidak ada data"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="type_selected.show_network"
                    >
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Paket HU
                        </div>
                        <v-autocomplete
                          v-model="package_hu"
                          :items="[1, 3, 7, 15]"
                          :rules="rulesHU"
                          @focus="() => (package_hu_error = '')"
                          :error-messages="package_hu_error"
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          dense
                          hide-details="auto"
                          no-data-text="Tidak ada data"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Sponsor
                          <span v-if="sponsor_name">
                            (
                            <span class="primary--text">{{ sponsor_name }}</span
                            >)
                          </span>
                        </div>
                        <v-text-field
                          v-model="sponsor"
                          @blur="checkUserMLM(sponsor, 'sponsor')"
                          @keypress="onlyNumber"
                          @paste="validatePaste($event)"
                          @focus="() => (sponsor_name_error = '')"
                          :error-messages="sponsor_name_error"
                          validate-on-blur
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          placeholder="Nomor Handphone Sponsor"
                          dense
                          hide-details="auto"
                          maxlength="16"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Posisi Berdasarkan
                        </div>
                        <v-autocomplete
                          v-model="position_by"
                          :items="position_option"
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          dense
                          hide-details="auto"
                          no-data-text="Tidak ada data"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="position_by == 'upline'"
                    >
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Upline
                          <span v-if="upline_name">
                            (
                            <span class="primary--text">{{ upline_name }}</span
                            >)
                          </span>
                        </div>
                        <v-text-field
                          v-model="upline"
                          @blur="checkUserMLM(upline, 'upline')"
                          @keypress="onlyNumber"
                          @paste="validatePaste($event, true)"
                          @focus="() => (upline_name_error = '')"
                          :error-messages="upline_name_error"
                          validate-on-blur
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          placeholder="Nomor Handphone Upline"
                          dense
                          hide-details="auto"
                          maxlength="16"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="position_by">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Posisi
                        </div>
                        <v-autocomplete
                          v-model="position_selected"
                          :items="position"
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          dense
                          hide-details="auto"
                          no-data-text="Tidak ada data"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Email
                        </div>
                        <v-text-field
                          v-model="email"
                          @focus="() => (email_error = '')"
                          :error-messages="email_error"
                          validate-on-blur
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          placeholder="Email"
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Password
                        </div>
                        <v-text-field
                          v-model="password"
                          :type="typePassword"
                          :append-icon="iconPassword"
                          @click:append="showPassword"
                          @focus="() => (password_error = '')"
                          :error-messages="password_error"
                          :rules="rulesPassword"
                          validate-on-blur
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          placeholder="Password"
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Bank
                        </div>
                        <v-autocomplete
                          v-model="bank_selected"
                          :items="list_bank_option"
                          item-text="bank_name"
                          item-value="bank_id"
                          :rules="rulesBank"
                          @focus="() => (bank_error = '')"
                          :error-messages="bank_error"
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          dense
                          hide-details="auto"
                          no-data-text="Tidak ada data"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          No Rekening
                        </div>
                        <v-text-field
                          v-model="bank_number"
                          @focus="() => (bank_number_error = '')"
                          :error-messages="bank_number_error"
                          :rules="rulesBanknumber"
                          validate-on-blur
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          placeholder="No Rekening"
                          dense
                          hide-details="auto"
                          maxlength="30"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div>
                        <div class="text-body-2 font-weight-bold pb-1">
                          Nama Pemilik Rekening
                        </div>
                        <v-text-field
                          v-model="account_name"
                          disabled
                          single-line
                          outlined
                          class="rounded-lg text-body-2"
                          placeholder="Nama Pemilik Rekening"
                          dense
                          hide-details="auto"
                          maxlength="30"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              depressed
              class="text-capitalize font-weight-bold rounded-lg"
              height="45"
              width="150"
              @click="saveDataProspect"
              >Simpan</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col class="py-0">
        <v-card elevation="0" class="pt-2 rounded-lg">
          <v-col class="px-2 py-2 text-body-2 my-auto">
            <v-row class="text-center">
              <v-col sm="12" lg="4" class="pb-2">
                <v-img
                  v-if="detailProfile.user_image"
                  width="70"
                  height="70"
                  class="mx-auto rounded-circle"
                  :src="
                    detailProfile.user_image
                      ? detailProfile.user_image
                      : '/assets/icons/default-toko.svg'
                  "
                ></v-img>
                <v-avatar v-else color="black" size="60">
                  <v-icon dark size="60">mdi-account-circle</v-icon>
                </v-avatar>
              </v-col>
              <v-col sm="12" lg="8">
                <div class="text-caption">{{ detailProfile.user_name }}</div>
                <div class="text-caption font-weight-bold">
                  {{ detailProfile.user_username }}
                </div>
                <div class="text-caption font-weight-bold " style="text-transform: capitalize">
                  {{ detailProfile.user_member_type ? 'Member ' + detailProfile.user_member_type : '' }}
                </div>
                <div class="text-caption">
                  <router-link
                    to="/profile"
                    class="text-deco grey--text text--darken-1"
                  >
                    <span>
                      <v-icon size="16" color="#e6c153">mdi-pencil</v-icon>Ubah
                      Profil
                    </span>
                  </router-link>
                </div>
              </v-col>
              <!-- <div v-if="detailProfile.user_network_id > 0" @click="loginToMLM" class="pt-2 primary--text text-caption font-weight-bold">Cek Bonus</div>
              <div v-else @click="bukaProspek" class="pt-2 primary--text text-caption font-weight-bold">Cek Bonus</div>-->
            </v-row>
            <div class>
              <v-divider></v-divider>
            </div>
            <!-- <div v-if="detailProfile.user_store_id">
							<v-btn block outlined color="dark" class="rounded-lg" @click="gotoToko">
								<div><v-icon color="dark">{{'mdi-store'}}</v-icon></div>
								<div class="pl-1 text-caption font-weight-bold">Toko Saya</div>
							</v-btn>
						</div>
						<div v-else>
							<div class="pb-1 text-caption grey--text text--darken-1">Anda belum memiliki toko</div>
							<v-btn block outlined color="dark" class="rounded-lg" @click="gotoBukaToko">
								<div><v-icon color="#e6c153">{{'mdi-store'}}</v-icon></div>
								<div class="pl-1 text-caption font-weight-bold">Buka Toko</div>
							</v-btn>
							<router-link to="/" v-if="false">
								<div class="pt-1 text-caption">Pelajari lebih lanjut di seller center</div>
							</router-link>
            </div>-->
            <div class="text-center">
              <v-btn
                x-small
                class="ma-2 white--text"
                color="black"
                @click="expand = !expand"
              >
                <v-icon v-if="expand">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
            </div>

            <v-expand-transition>
              <div v-show="expand" class="text-body-2">
                <v-list dense>
                  <template v-for="(item, index) in menu">
                    <template v-if="!item.children">
                      <v-list-item link :to="item.link" :key="index">
                        <v-list-item-icon>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-else>
                      <v-list-group :value="currentRoute.includes('transaction')" class="v-list-group--active" :prepend-icon="item.icon" :key="index">
                        <template v-slot:activator>
                          <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </template>
                        <v-list-item
                          link
                          v-for="(child, i) in item.children"
                          :key="i"
                          :to="child.link"
                        >
                          <v-list-item-title class="ms-5 ps-5">{{
                            child.text
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list-group>
                    </template>
                  </template>
                  <v-list-item link @click="onLogout">
                    <v-list-item-icon>
                      <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>

                <!-- <v-expansion-panels
                  tile
                  v-if="false"
                  multiple
                  accordion
                  v-model="panel"
                  class="accordion-filter accordion-profile justify-start"
                >
                  <v-expansion-panel v-if="false">
                    <v-expansion-panel-header
                      class="text-uppercase font-weight-bold text-caption"
                      >Pesan</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-list class="py-0">
                        <v-list-item dense class="px-0">
                          <router-link
                            to="/"
                            class="text-deco grey--text text--darken-1"
                          >
                            <v-list-item-title class="text-caption"
                              >Pesan</v-list-item-title
                            >
                          </router-link>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      expand-icon
                      class="text-uppercase font-weight-bold text-caption"
                    >
                      <span class="text-md-center">
                        <v-icon class="mr-1 float-md-left">mdi-account</v-icon
                        >Akun
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list class="py-0 ms-5">
                        <v-list-item dense class="px-0 ms-2">
                          <router-link
                            to="/profile?param=akun"
                            class="text-deco grey--text text--darken-1"
                          >
                            <v-list-item-title class="text-caption"
                              >Akun</v-list-item-title
                            >
                          </router-link>
                        </v-list-item>
                        <v-list-item dense class="px-0 ms-2" v-if="false">
                          <router-link
                            to="/profile?param=alamat"
                            class="text-deco grey--text text--darken-1"
                          >
                            <v-list-item-title class="text-caption"
                              >Daftar Alamat</v-list-item-title
                            >
                          </router-link>
                        </v-list-item>
                        <v-list-item dense class="px-0 ms-2">
                          <router-link
                            to="/profile?param=alamat_v2"
                            class="text-deco grey--text text--darken-1"
                          >
                            <v-list-item-title class="text-caption"
                              >Daftar Alamat</v-list-item-title
                            >
                          </router-link>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels> -->
              </div>
            </v-expand-transition>

            <div class="pt-5 pb-2"></div>
            <!-- <v-btn block text color="pink" class="rounded-lg" @click="onLogout">
							<div class="pr-2 text-caption font-weight-bold">Keluar</div>
							<v-icon small>mdi-logout</v-icon>
            </v-btn>-->
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      typePassword: "password",
      iconPassword: "mdi-eye",
      panel: [],
      dialog: false,
      sponsor: "",
      expand: true,
      upline: "",
      position_selected: "",
      identity_number: "",
      package_hu: 1,
      sponsor_name: "",
      upline_name: "",
      position_by: "sponsor",
      type_member_option: [],
      list_bank_option: [],
      type_selected: {},
      bank_selected: "",
      bank_number: "",
      password: "",
      email: "",
      position_option: [
        {
          text: "Sponsor",
          value: "sponsor",
        },
        {
          text: "Upline",
          value: "upline",
        },
      ],
      position: [
        {
          text: "Otomatis",
          value: "",
        },
        {
          text: "Kiri",
          value: "L",
        },
        {
          text: "Kanan",
          value: "R",
        },
      ],
      ktp_error: "",
      sponsor_name_error: "",
      upline_name_error: "",
      member_type_error: "",
      package_hu_error: "",
      email_error: "",
      password_error: "",
      bank_error: "",
      bank_number_error: "",
      account_name: "",
      rulesTypeMember: [(v) => !!v || "Tipe member tidak boleh kosong "],
      rulesBank: [(v) => !!v || "Bank tidak boleh kosong "],
      rulesBanknumber: [(v) => !!v || "Nomor Rekening tidak boleh kosong "],
      rulesHU: [
        (v) => v <= 15 || "Maksimal 15 HU",
        (v) => v >= 0 || "Data tidak valid",
      ],
      rulesPassword: [
        (v) => !!v || "Password tidak boleh kosong",
        (v) => v.length > 5 || "Data tidak valid",
      ],
    };
  },
  computed: {
    currentRoute(){
      return this.$route.path
    },
    ...mapState("profile", ["detailProfile", "responseError"]),
    ...mapState("auth", ["userData"]),
    menu() {
      return [
        {
          text: "Dashboard",
          link: "/dashboard",
          icon: "mdi-home",
        },
        {
          text: "Pesanan",
          link: "/",
          icon: "mdi-clipboard-text",
          children: [
            {
              text: "Daftar Pesanan",
              link: "/transaction",
              icon: "mdi-clipboard-list",
            },
            {
              text: "Daftar Pesanan Tempo",
              link: "/tempo-transaction",
              icon: "mdi-clipboard-text",
            },
            {
              text: "Riwayat Pembayaran Tempo",
              link: "/tempo-payment-transaction",
              icon: "mdi-clipboard-text",
            },
            {
              text: "Riwayat Transaksi Nego",
              link: "/nego-history-transaction",
              icon: "mdi-clipboard-text",
            },
          ],
        },
        {
          text: "Akun",
          link: "/profile",
          icon: "mdi-account",
        },
        {
          text: "Daftar Alamat",
          link: "/address-list",
          icon: "mdi-map-marker",
        },
      ];
    },
    rulesKTP() {
      let rules = [];
      if (this.identity_number) {
        rules = [(v) => v.length == 16 || "No. KTP tidak sesuai"];
      }
      return rules;
    },
  },
  watch: {},
  methods: {
    onLogout() {
      this.$store.dispatch("auth/logout").then(() => {
        window.location.replace(process.env.VUE_APP_HOMEPAGE + "logout ");
      });
    },
    ...mapActions("auth", ["logout"]),
    ...mapMutations(["makeAlert", "progress"]),
    ...mapActions("profile", [
      "getProfileDetail",
      "loginMLM",
      "checkMLM",
      "checkKTPMember",
      "getTypeMember",
      "getBankProspect",
      "getProspect",
      "saveProspect",
    ]),

    showPassword() {
      if (this.typePassword == "password") {
        this.typePassword = "text";
        this.iconPassword = "mdi-eye-off";
      } else {
        this.typePassword = "password";
        this.iconPassword = "mdi-eye";
      }
    },
    gotoBukaToko() {
      this.$router.push({ name: "buka-toko" });
    },
    gotoToko() {
      this.$router.push("/seller");
    },
    loginToMLM() {
      this.loginMLM().then(({ data }) => {
        window.open(data.url);
      });
    },
    async bukaProspek() {
      await this.getDataProspect();
      this.dialog = true;
      this.email = await this.userData.user_email;
      this.account_name = await this.userData.user_name;
    },
    checkUserMLM(username, type) {
      if (username) {
        this.checkMLM({
          username: username,
        })
          .then(({ data }) => {
            if (type == "sponsor") {
              this.sponsor_name = data.memberName;
              this.sponsor_name_error = "";
            } else if (type == "upline") {
              this.upline_name = data.memberName;
              this.upline_name_error = "";
            }
          })
          .catch((err) => {
            this.makeAlert({
              code: "error_response",
              type: "error",
              message: "No. HP Upline/Sponsor tidak ditemukan",
              show: true,
            });
            if (type == "sponsor") {
              this.sponsor_name_error = "No. HP Sponsor " + err.message;
              this.sponsor_name = "";
            } else if (type == "upline") {
              this.upline_name_error = "No. HP Upline " + err.message;
              this.upline_name = "";
            }
          });
      } else {
        if (type == "sponsor") {
          this.sponsor_name = "";
          this.sponsor_name_error = "";
        } else if (type == "upline") {
          this.upline_name = "";
          this.upline_name_error = "";
        }
      }
    },
    checkKTP() {
      this.checkKTPMember({
        identity_number: this.identity_number,
      })
        .then(() => {
          this.ktp_error = "";
        })
        .catch((err) => {
          if (err.message == "error_validation") {
            this.ktp_error = err.data.identity_number;
          }
        });
    },
    saveDataProspect() {
      let params = {
        member_identity_no: this.identity_number,
        network_sponsor_username: this.sponsor,
        position: this.position_by == "sponsor" ? this.position_selected : "",
        network_upline_username:
          this.position_by == "upline" ? this.upline : "",
        position_from_upline:
          this.position_by == "upline" ? this.position_selected : "",
        member_type: this.type_selected.value,
        package_hu: this.package_hu,
        email: this.email,
        password: this.password,
        bank_id: this.bank_selected,
        bank_number: this.bank_number,
        bank_account_name: this.account_name,
      };
      this.package_hu_error = "";
      this.member_type_error = "";
      this.saveProspect(params)
        .then(() => {
          this.dialog = false;
        })
        .catch(() => {
          if (Object.values(this.responseError).length > 0) {
            this.package_hu_error = this.responseError.package_hu;
            this.member_type_error = this.responseError.member_type;
            this.email_error = this.responseError.email;
            this.password_error = this.responseError.password;
            this.bank_error = this.responseError.bank_id;
            this.bank_number_error = this.responseError.bank_number;
          } else {
            this.package_hu_error = "";
            this.member_type_error = "";
            this.email_error = "";
            this.password_error = "";
            this.bank_error = "";
            this.bank_number_error = "";
          }
        });
    },
    async validatePaste(val, ref) {
      let pasted = await val.clipboardData.getData("text");
      setTimeout(() => {
        if (!parseInt(pasted)) {
          if (ref === true) {
            this.upline = "";
          } else {
            this.sponsor = "";
          }
        }
      });
    },
    getDataProspect() {
      this.getProspect()
        .then(async ({ results }) => {
          this.position_by = "sponsor";
          this.sponsor = await results.network_sponsor_username;
          this.position_selected = await results.position_from_sponsor;
          if (results.network_upline_username) {
            this.position_by = "upline";
          }
          this.upline = await results.network_upline_username;
          this.position_selected = await results.position_from_upline;
          this.identity_number = await results.member_identity_no;
          this.package_hu = await parseInt(results.package_hu);
          this.email = results.member_email;
          this.password = "";
          this.bank_number = results.member_bank_account_no;
          this.bank_selected = results.member_bank_id;
          this.account_name = results.member_bank_account_name;
          let selectedType = this.type_member_option.find(
            (el) => el.value == results.member_type
          );
          this.type_selected = selectedType ? selectedType : {};
        })
        .catch(() => {
          this.sponsor = this.userData.user_sponsor_user_username;
        });
    },
  },
  created() {
    this.getProfileDetail();
    this.type_selected.show_network = false;
    if (!(this.detailProfile.user_network_id > 0)) {
      this.getDataProspect();

      this.getTypeMember().then(({ results }) => {
        this.type_member_option = results;
      });
      this.getBankProspect().then(({ results }) => {
        this.list_bank_option = results;
      });
    }
  },
};
</script>
